<template>
  <div class="category-control">
    <ui-loader v-if="inLoading" />
    <template v-if="message.is_trash">
      <button
        class="category-control__item bg-success"
        @click.stop="moveHandler('trash', false)"
      >
        {{ label('trash', true) }}
      </button>
      <button
        class="category-control__item bg-danger"
        @click.stop="deleteMessage"
      >
        Delete
      </button>
    </template>
    <template v-else>
      <button
        class="category-control__item bg-warning"
        @click.stop="moveHandler('spam', !message.is_spam)"
      >
        {{ label('spam', message.is_spam) }}
      </button>
      <button
        class="category-control__item bg-danger"
        @click.stop="moveHandler('trash', !message.is_trash)"
      >
        {{ label('trash', message.is_trash) }}
      </button>
    </template>
    <button
      v-if="logs"
      class="category-control__item bg-info"
      @click.stop="$emit('show-logs')"
    >
      Show Logs
    </button>
  </div>
</template>

<script>
import API from '../../../../api'
import UiLoader from '../../ui-kit/ui-loader.vue'
export default {
  components: { UiLoader },
  name: 'category-control',
  props: {
    message: Object,
    logs: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    endpointId() {
      return this.$store.getters.endpointId
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    }
  },
  data() {
    return {
      inLoading: false
    }
  },
  methods: {
    label(root, status) {
      let prefix = 'Add to'
      if (status) {
        prefix = 'Remove from'
      }
      return `${prefix} ${root}`
    },
    async deleteMessage() {
      this.$dialog
        .confirm(
          'Are you sure you want to delete this message? This action is irreversible.'
        )
        .then(async () => {
          this.inLoading = true
          try {
            await API.messages.remove({
              projectId: this.currentProject.id,
              endpointId: this.endpointId,
              uuid: this.message.uuid
            })
            this.$emit('change')
          } catch (err) {
            console.error(err)
          } finally {
            this.inLoading = false
          }
        })
    },
    async moveHandler(category, action) {
      this.inLoading = true
      try {
        await API.messages.updateCategory({
          projectId: this.currentProject.id,
          endpointId: this.endpointId,
          categoryDirection: action ? 'move' : 'remove',
          uuid: this.message.uuid,
          category
        })
        this.$emit('change')
      } catch (err) {
        console.error(err)
      } finally {
        this.inLoading = false
      }
    }
  }
}
</script>

<style lang="scss">
.category-control {
  position: relative;
  display: flex;
  &__item {
    display: block;
    padding: 4px 6px 2px;
    color: #fff;
    font-size: 10px;
    text-transform: uppercase;
    border: 0;
    transition: 0.2s;
    &:first-child {
      border-radius: $border-radius-sm 0 0 $border-radius-sm;
    }
    &:last-child {
      border-radius: 0 $border-radius-sm $border-radius-sm 0;
    }
    &[disabled] {
      opacity: 0.6;
      pointer-events: none;
    }
  }
}
</style>
